/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Placeholder_SkillsInputs */

const en_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const de_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const fr_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const es_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const it_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const nl_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const pl_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const fi_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const da_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

const sv_story_bank_placeholder_skills = /** @type {(inputs: Story_Bank_Placeholder_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Management, SQL, React`)
};

/**
* | output |
* | --- |
* | "Project Management, SQL, React" |
*
* @param {Story_Bank_Placeholder_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_placeholder_skills = /** @type {((inputs?: Story_Bank_Placeholder_SkillsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Placeholder_SkillsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_placeholder_skills(inputs)
	if (locale === "fr") return fr_story_bank_placeholder_skills(inputs)
	if (locale === "es") return es_story_bank_placeholder_skills(inputs)
	if (locale === "it") return it_story_bank_placeholder_skills(inputs)
	if (locale === "nl") return nl_story_bank_placeholder_skills(inputs)
	if (locale === "pl") return pl_story_bank_placeholder_skills(inputs)
	if (locale === "fi") return fi_story_bank_placeholder_skills(inputs)
	if (locale === "da") return da_story_bank_placeholder_skills(inputs)
	if (locale === "sv") return sv_story_bank_placeholder_skills(inputs)
	return en_story_bank_placeholder_skills(inputs)
});